import React from 'react'

/**
 * Hook to detect if the device is an iPad
 * This is used to determine if the view mode toggle should be shown
 * Only iPads should show the toggle, not mobile phones
 * Note: This does NOT respect the view mode override - it's for UI display purposes only
 */
export function useIsMobileOrTablet(): boolean {
  return React.useMemo(() => {
    if (typeof window === 'undefined') {
      return false
    }

    const userAgent = navigator.userAgent.toLowerCase()

    // Only show toggle on iPads (not iPhones or Android devices)
    const isIPad = /ipad/i.test(userAgent)

    return isIPad
  }, [])
}
